// Core
import { Map, Range } from 'immutable';
import moment from 'moment';
import { createQuery } from 'helpers/query';
import { handleActions } from 'redux-actions';

// Instruments
import { queriesActions as actions } from './actions';
import { QUERY_PARAMS, compileQuery } from 'helpers/query';

const initalState = Map({
    main: createQuery(),
});

export const queriesReducer = handleActions(
    {
        [actions.createQuery]: (state, { payload: { queryId, initialParams }}) => {
            return state.set(queryId, createQuery(initialParams));
        },
        [actions.setQuery]: (state, { payload: { queryId, query }}) => {
            return state.set(queryId, query);
        },
        [actions.createQueryFromOffer]: (state, { payload: { queryId, hotel, offer, overrides = {}}}) => {
            return state.set(
                queryId,
                createQuery({
                    [QUERY_PARAMS.COUNTRY]:   hotel.country.id,
                    [QUERY_PARAMS.DEPARTURE]: offer.departure,
                    [QUERY_PARAMS.DURATION]:  Map({
                        from: offer.days,
                        to:   offer.days,
                    }),
                    [QUERY_PARAMS.DATES]: Map({
                        from: moment(offer.date),
                        to:   moment(offer.date),
                    }),
                    [QUERY_PARAMS.ADULTS]:    offer.adults,
                    [QUERY_PARAMS.CHILDREN]:  Range(0, offer.children).toArray(),
                    [QUERY_PARAMS.HOTELS]:    [hotel.id],
                    [QUERY_PARAMS.TRANSPORT]: Map({ [offer.transport]: true }),
                    [QUERY_PARAMS.FOOD]:      Map({ [offer.food]: true }),
                    ...overrides,
                })
            );
        },
        [actions.changeQueryParam]: (state, { payload: { queryId, paramName, paramValue }}) => {
            if (Array.isArray(paramName)) {
                return state.mergeIn([queryId], paramValue);
            }

            return state.setIn([queryId, paramName], paramValue);
        },
        [actions.resetQueryParam]: (state, { payload: { queryId, paramName }}) => {
            return state.setIn([queryId, paramName], createQuery().get(paramName));
        },
        [actions.parseQueryParamSuccess]: (state, { payload: { queryId, paramName, paramValue }}) => {
            return state.setIn([queryId, paramName], paramValue);
        },
        [actions.compileQueryString]: (state, { payload: queryId }) => {
            return state.setIn(
                [queryId, 'hash'],
                compileQuery(state.get(queryId))
            );
        },
    },
    initalState
);
